// import React from 'react';
// import { 
//   Coins, Landmark, Scale, ShieldCheck, 
//   Users2, FileText, Calculator, HelpCircle, 
//   TrendingUp, CheckCircle, AlertTriangle
// } from 'lucide-react'; // run: npm i lucide-react
// import { ServicePageHeader } from '../ServicePageHeader';

// export default function EstateLiquidationServices() {
  
//   // Core areas of expertise under estate division
//   const liquidationAreas = [
//     {
//       title: "تصفية تركات الشركات والكيانات التجارية",
//       desc: "إعادة تقييم حصص الورثة في الشركات القائمة، وتحويل الشركات العائلية إلى شركات مساهمة أو مغلقة لمنع انهيار الكيان التجاري.",
//       icon: <Landmark className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "تقسيم التركات العقارية والأراضي",
//       desc: "فرز وتخصيص الأصول العقارية الكبرى والمخططات، بالتعاون مع المقيّمين المعتمدين (تقييم) لضمان التوزيع العادل نظاماً وشرعاً.",
//       icon: <TrendingUp className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "القسمة الرضائية والصلح بين الورثة",
//       desc: "إدارة المفاوضات الودية بين الأطراف وصياغة محاضر وعقود قسمة رضائية محكمة وتوثيقها رسمياً لتجنب النزاعات الطويلة.",
//       icon: <Users2 className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "القسمة الإجبارية والتقاضي القضائي",
//       desc: "تمثيل الورثة أمام محاكم الأحوال الشخصية والمحاكم العامة في دعاوى محاسبة النظار، عزل الوصي، وقسمة الإجبار.",
//       icon: <Scale className="w-6 h-6 text-amber-600" />
//     }
//   ];

//   return (
//     <div className="bg-slate-50 text-right font-sans" dir="rtl">
//       <ServicePageHeader 
//         title="تصفية التركات والأموال المشتركة"
//         description="نقدم حلولاً قانونية وشرعية متكاملة لتصفية التركات المعقدة والأموال المشتركة"
//       />
//       {/* Hero Header Section */}
//       <section className="relative bg-slate-900 text-white py-24 px-4 overflow-hidden">
//         <div className="absolute inset-0 opacity-15 bg-[url('https://images.unsplash.com/photo-1543269865-cbf427effbad?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
//         <div className="max-w-6xl mx-auto relative z-10 text-center">
//           <span className="text-amber-500 font-semibold text-sm md:text-base tracking-wide block mb-3">حفظ الحقوق واستدامة الأصول العائلية</span>
//           <h1 className="text-3xl md:text-5xl font-bold mb-6 text-slate-100 leading-tight">تقسيم وتصفية التركات والأموال المشتركة</h1>
//           <p className="text-slate-300 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
//             نقدم حلولاً قانونية وشرعية متكاملة لتصفية التركات المعقدة والأموال المشتركة. نجمع بين الكفاءة الحسابية والخبرة القضائية لحماية ثروات العائلات واستمرار أعمالها عبر الأجيال.
//           </p>
//         </div>
//       </section>

//       {/* Philosophy: Preserving Legacies */}
//       <section className="max-w-6xl mx-auto py-20 px-4">
//         <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100 flex flex-col lg:flex-row gap-12 items-center">
//           <div className="flex-1">
//             <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-6 leading-tight">
//               إدارة التركات الشائكة برؤية نظامية حكيمة
//             </h2>
//             <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-4">
//               تجميد الثروات والأصول بعد وفاة المورّث نتيجة الخلافات بين الشركاء أو الورثة يعد من أكبر المخاطر التي تهدد قطاع الأعمال والمجموعات العائلية في المملكة. إن غياب التقييم العادل والمحاسبة الدقيقة قد يؤدي إلى تآكل قيمة هذه الأصول.
//             </p>
//             <p className="text-gray-600 text-base md:text-lg leading-relaxed">
//               تتركز مهمتنا في مكتبنا على توفير بيئة قانونية آمنة ومحايدة لفرز واستخراج الأنصبة الشرعية، بدءاً من حصر التريّكات، رصد الديون المستحقة والوصايا، وحتى الإشراف الكامل على البيع بالمزاد العلني أو الإفراز العقاري وتوزيع السيولة النقدية.
//             </p>
//           </div>
          
//           <div className="w-full lg:w-80 bg-slate-900 text-white p-6 rounded-xl border border-slate-800 flex flex-col justify-between shrink-0 shadow-lg">
//             <div>
//               <Calculator className="w-12 h-12 text-amber-500 mb-4" />
//               <h3 className="text-lg font-bold text-slate-100 mb-2">الدقة المحاسبية والقانونية</h3>
//               <p className="text-slate-400 text-xs leading-relaxed">
//                 ندمج بين قواعد المواريث الشرعية الصارمة والأنظمة المالية والشركاتية الحديثة لضمان محاسبة وحصر تصفية خالٍ من الأخطاء الثغراتية.
//               </p>
//             </div>
//             <div className="mt-6 pt-4 border-t border-slate-800 flex items-center justify-between text-xs text-amber-500">
//               <span>مطابق لنظام الأحوال الشخصية الجديد</span>
//               <ShieldCheck className="w-4 h-4" />
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Grid Layout: Core liquidations options */}
//       <section className="max-w-6xl mx-auto py-12 px-4">
//         <div className="text-center mb-16">
//           <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-3">خدماتنا في تصفية الأصول والتركات</h2>
//           <p className="text-gray-500">تغطية قانونية شاملة لكافة مستويات فرز الملكيات المشتركة والتركات</p>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//           {liquidationAreas.map((area, index) => (
//             <div key={index} className="bg-white p-8 rounded-xl border border-gray-100 hover:border-amber-500 hover:shadow-md transition-all duration-300">
//               <div className="p-3 bg-slate-50 rounded-lg w-fit text-slate-700 mb-4">
//                 {area.icon}
//               </div>
//               <h3 className="text-xl font-bold text-slate-800 mb-2">{area.title}</h3>
//               <p className="text-gray-500 text-sm leading-relaxed">{area.desc}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Process Workflow Steps */}
//       <section className="bg-slate-900 text-white py-20 px-4">
//         <div className="max-w-6xl mx-auto">
//           <div className="text-center mb-16">
//             <h2 className="text-2xl md:text-4xl font-bold mb-3">مراحل تصفية التركة لدينا</h2>
//             <p className="text-slate-400">آلية عمل منظمة وموثقة لضمان الشفافية وإنهاء الإجراءات بأسرع وقت ممكن</p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
            
//             {/* Step 1 */}
//             <div className="bg-slate-800/40 p-6 rounded-xl border border-slate-700">
//               <div className="w-8 h-8 rounded-full bg-amber-600 text-white flex items-center justify-center font-bold text-sm mb-4">١</div>
//               <h3 className="text-lg font-bold mb-2">الحصر المالي والقانوني</h3>
//               <p className="text-slate-400 text-xs leading-relaxed">استخراج صك حصر الورثة، وتتبع كافة أصول المتوفى العقارية والمالية والتجارية داخل وخارج المملكة عبر الجهات الرسمية.</p>
//             </div>

//             {/* Step 2 */}
//             <div className="bg-slate-800/40 p-6 rounded-xl border border-slate-700">
//               <div className="w-8 h-8 rounded-full bg-amber-600 text-white flex items-center justify-center font-bold text-sm mb-4">٢</div>
//               <h3 className="text-lg font-bold mb-2">تطهير التركة وتسوية الالتزامات</h3>
//               <p className="text-slate-400 text-xs leading-relaxed">سداد ديون المتوفى الممتازة والعادية، إخراج الحقوق المتعلقة بالتركة، وتنفيذ الوصايا الشرعية المستوفية للشروط النظامية.</p>
//             </div>

//             {/* Step 3 */}
//             <div className="bg-slate-800/40 p-6 rounded-xl border border-slate-700">
//               <div className="w-8 h-8 rounded-full bg-amber-600 text-white flex items-center justify-center font-bold text-sm mb-4">٣</div>
//               <h3 className="text-lg font-bold mb-2">الإفراز والتوزيع النهائي</h3>
//               <p className="text-slate-400 text-xs leading-relaxed">توزيع السيولة النقدية، نقل الملكيات والأسهم للورثة، أو إحالة الأصول غير القابلة للقسمة للمزاد العلني لتقسيم ثمنها.</p>
//             </div>

//           </div>
//         </div>
//       </section>

//       {/* Preventive Advice Banner */}
//       <section className="max-w-4xl mx-auto py-16 px-4">
//         <div className="bg-amber-50 rounded-xl border border-amber-200 p-6 flex gap-4 items-start">
//           <AlertTriangle className="w-6 h-6 text-amber-600 shrink-0 mt-0.5" />
//           <div>
//             <h4 className="font-bold text-slate-800 mb-1">تنويه قانوني هام للمجموعات العائلية:</h4>
//             <p className="text-amber-950 text-sm leading-relaxed">
//               إن الاستمرار في إدارة التركات الضخمة بشكل ودي دون فرز قانوني رسمي أو صياغة ميثاق عائلي (Family Constitution) للشركات المشتركة يفتح الباب لثغرات قضائية قد تعطل الحسابات البنكية للمنشأة وتوقف تراخيصها التشغيلية عند حدوث أي خلاف بسيط.
//             </p>
//           </div>
//         </div>
//       </section>

//     </div>
//   );
// }

import React from 'react';
import { 
  Coins, Landmark, Scale, ShieldCheck, 
  Users2, FileText, Calculator, HelpCircle, 
  TrendingUp, CheckCircle, AlertTriangle
} from 'lucide-react';
import { ServicePageHeader } from '../ServicePageHeader';

export default function EstateLiquidationServices() {
  
  // Core areas of expertise under estate division - Refactored to Navy Light
  const liquidationAreas = [
    {
      title: "تصفية تركات الشركات والكيانات التجارية",
      desc: "إعادة تقييم حصص الورثة في الشركات القائمة، وتحويل الشركات العائلية إلى شركات مساهمة أو مغلقة لمنع انهيار الكيان التجاري.",
      icon: <Landmark className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "تقسيم التركات العقارية والأراضي",
      desc: "فرز وتخصيص الأصول العقارية الكبرى والمخططات، بالتعاون مع المقيّمين المعتمدين (تقييم) لضمان التوزيع العادل نظاماً وشرعاً.",
      icon: <TrendingUp className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "القسمة الرضائية والصلح بين الورثة",
      desc: "إدارة المفاوضات الودية بين الأطراف وصياغة محاضر وعقود قسمة رضائية محكمة وتوثيقها رسمياً لتجنب النزاعات الطويلة.",
      icon: <Users2 className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "القسمة الإجبارية والتقاضي القضائي",
      desc: "تمثيل الورثة أمام محاكم الأحوال الشخصية والمحاكم العامة في دعاوى محاسبة النظار، عزل الوصي، وقسمة الإجبار.",
      icon: <Scale className="w-6 h-6 text-indigo-950" />
    }
  ];

  return (
    <div className="bg-white text-right font-sans min-h-screen" dir="rtl">
      <ServicePageHeader 
        title="تصفية التركات والأموال المشتركة"
        description="نقدم حلولاً قانونية وشرعية متكاملة لتصفية التركات المعقدة والأموال المشتركة"
      />
      
      {/* Hero Header Section - Converted to Premium Light Mode */}
      <section className="relative bg-slate-50 border-b border-slate-100 py-24 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1543269865-cbf427effbad?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
        {/* White/Slate overlay for modern executive contrast */}
        <div className="absolute inset-0 bg-white/90 backdrop-blur-[1px]"></div>
        
        <div className="max-w-6xl mx-auto relative z-10 text-center">
          <span className="text-blue-700 font-bold text-xs md:text-sm tracking-wide block mb-3 uppercase">حفظ الحقوق واستدامة الأصول العائلية</span>
          <h1 className="text-3xl md:text-5xl font-extrabold mb-6 text-indigo-950 leading-tight">تقسيم وتصفية التركات والأموال المشتركة</h1>
          <p className="text-slate-600 max-w-3xl mx-auto text-base md:text-lg leading-relaxed font-light">
            نقدم حلولاً قانونية وشرعية متكاملة لتصفية التركات المعقدة والأموال المشتركة. نجمع بين الكفاءة الحسابية والخبرة القضائية لحماية ثروات العائلات واستمرار أعمالها عبر الأجيال.
          </p>
        </div>
      </section>

      {/* Philosophy: Preserving Legacies */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-slate-200/60 flex flex-col lg:flex-row gap-12 items-center">
          <div className="flex-1">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-6 leading-tight">
              إدارة التركات الشائكة برؤية نظامية حكيمة
            </h2>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed mb-4 font-light">
              تجميد الثروات والأصول بعد وفاة المورّث نتيجة الخلافات بين الشركاء أو الورثة يعد من أكبر المخاطر التي تهدد قطاع الأعمال والمجموعات العائلية في المملكة. إن غياب التقييم العادل والمحاسبة الدقيقة قد يؤدي إلى تآكل قيمة هذه الأصول.
            </p>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed font-light">
              تتركز مهمتنا في مكتبنا على توفير بيئة قانونية آمنة ومحايدة لفرز واستخراج الأنصبة الشرعية، بدءاً من حصر التريّكات، رصد الديون المستحقة والوصايا، وحتى الإشراف الكامل على البيع بالمزاد العلني أو الإفراز العقاري وتوزيع السيولة النقدية.
            </p>
          </div>
          
          {/* Executive Info Box - Refactored to Navy Light Style */}
          <div className="w-full lg:w-80 bg-slate-50 text-indigo-950 p-6 rounded-xl border border-slate-200/60 flex flex-col justify-between shrink-0 shadow-sm">
            <div>
              <Calculator className="w-12 h-12 text-blue-700 mb-4" />
              <h3 className="text-lg font-bold text-indigo-950 mb-2">الدقة المحاسبية والقانونية</h3>
              <p className="text-slate-500 text-xs leading-relaxed font-light">
                ندمج بين قواعد المواريث الشرعية الصارمة والأنظمة المالية والشركاتية الحديثة لضمان محاسبة وحصر تصفية خالٍ من الأخطاء الثغراتية.
              </p>
            </div>
            <div className="mt-6 pt-4 border-t border-slate-200 flex items-center justify-between text-[11px] text-blue-700 font-semibold">
              <span>مطابق لنظام الأحوال الشخصية الجديد</span>
              <ShieldCheck className="w-4 h-4" />
            </div>
          </div>
        </div>
      </section>

      {/* Grid Layout: Core liquidations options - Converted to Premium Light Grid */}
      <section className="bg-slate-50/50 border-y border-slate-100 py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-3">خدماتنا في تصفية الأصول والتركات</h2>
            <p className="text-slate-500 text-sm md:text-base font-light">تغطية قانونية شاملة لكافة مستويات فرز الملكيات المشتركة والتركات</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {liquidationAreas.map((area, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border-t-4 border-t-indigo-950 border-x border-b border-slate-100 shadow-sm hover:shadow-md transition-all duration-300">
                <div className="bg-slate-50 p-3 rounded-lg w-fit text-slate-700 mb-4">
                  {area.icon}
                </div>
                <h3 className="text-xl font-bold text-indigo-950 mb-2">{area.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed font-light">{area.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Workflow Steps - Converted completely to Premium Light Grid */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-3">مراحل تصفية التركة لدينا</h2>
          <p className="text-slate-500 text-sm md:text-base font-light">آلية عمل منظمة وموثقة لضمان الشفافية وإنهاء الإجراءات بأسرع وقت ممكن</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          
          {/* Step 1 */}
          <div className="bg-white p-6 rounded-xl border border-slate-100 shadow-sm relative hover:shadow-md transition-shadow duration-200">
            <div className="w-8 h-8 rounded-full bg-indigo-950 text-white flex items-center justify-center font-bold text-sm mb-4 shadow-sm">١</div>
            <h3 className="text-lg font-bold text-indigo-950 mb-2">الحصر المالي والقانوني</h3>
            <p className="text-slate-500 text-xs leading-relaxed font-light">استخراج صك حصر الورثة، وتتبع كافة أصول المتوفى العقارية والمالية والتجارية داخل وخارج المملكة عبر الجهات الرسمية.</p>
          </div>

          {/* Step 2 */}
          <div className="bg-white p-6 rounded-xl border border-slate-100 shadow-sm relative hover:shadow-md transition-shadow duration-200">
            <div className="w-8 h-8 rounded-full bg-indigo-950 text-white flex items-center justify-center font-bold text-sm mb-4 shadow-sm">٢</div>
            <h3 className="text-lg font-bold text-indigo-950 mb-2">تطهير التركة وتسوية الالتزامات</h3>
            <p className="text-slate-500 text-xs leading-relaxed font-light">سداد ديون المتوفى الممتازة والعادية، إخراج الحقوق المتعلقة بالتركة، وتنفيذ الوصايا الشرعية المستوفية للشروط النظامية.</p>
          </div>

          {/* Step 3 */}
          <div className="bg-white p-6 rounded-xl border border-slate-100 shadow-sm relative hover:shadow-md transition-shadow duration-200">
            <div className="w-8 h-8 rounded-full bg-indigo-950 text-white flex items-center justify-center font-bold text-sm mb-4 shadow-sm">٣</div>
            <h3 className="text-lg font-bold text-indigo-950 mb-2">الإفراز والتوزيع النهائي</h3>
            <p className="text-slate-500 text-xs leading-relaxed font-light">توزيع السيولة النقدية، نقل الملكيات والأسهم للورثة، أو إحالة الأصول غير القابلة للقسمة للمزاد العلني لتقسيم ثمنها.</p>
          </div>

        </div>
      </section>

      {/* Preventive Advice Banner - Adjusted to Slate Balance Tone */}
      <section className="max-w-4xl mx-auto pb-20 px-4">
        <div className="bg-slate-50 rounded-xl border border-slate-200/60 p-6 flex gap-4 items-start shadow-sm">
          <AlertTriangle className="w-6 h-6 text-indigo-950 shrink-0 mt-0.5" />
          <div>
            <h4 className="font-bold text-indigo-950 mb-1">تنويه قانوني هام للمجموعات العائلية:</h4>
            <p className="text-slate-600 text-sm leading-relaxed font-light">
              إن الاستمرار في إدارة التركات الضخمة بشكل ودي دون فرز قانوني رسمي أو صياغة ميثاق عائلي (Family Constitution) للشركات المشتركة يفتح الباب لثغرات قضائية قد تعطل الحسابات البنكية للمنشأة وتوقف تراخيصها التشغيلية عند حدوث أي خلاف بسيط.
            </p>
          </div>
        </div>
      </section>

    </div>
  );
}